<template>
  <div>
    <div class="row pricing-table-one">
      <div class="pricing-table wow move-up" v-for="(pricing, index) in pricingTable" :key="index"
           :class="{'pricing-table--popular__bg': pricing.active}">
        <div class="pricing-table__inner" :class="{'bg-gradient': pricing.active}">
          <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
            <span>Popular Choice</span>
          </div>
          <div class="pricing-table__header">
            <div class="pricing-table__image">
              <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
            </div>
            <h5 class="pricing-table__title">{{ pricing.title }}</h5>
            <div class="pricing-table__price-wrap">
              <h6 class="currency">$</h6>
              <h6 class="price">{{ pricing.value }}</h6>
              <h6 class="period">/{{ pricing.duration }}</h6>
            </div>
          </div>
          <div class="pricing-table__body">
            <ul class="pricing-table__list">
              <li v-for="(list, index) in pricing.price" :key="index">{{ list }}</li>
            </ul>
          </div>
          <div class="pricing-table__footer">
            <a @click="gotologin" class="ht-btn ht-btn--outline ht-btn-default"
               :class="{'btn--white': pricing.active}">Get started</a>
          </div>

        </div>
        <div style="padding-top: 15px;">Compatible with
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/>
          </svg>
          + Premium + Sales Navigator
        </div>

      </div>

    </div>
    <div style="margin-top: 10%;margin-bottom: -5%">
      <div>*All plans come with a 7-day obligation-free trial. No credit card required,unsubscribe
        anytime.
      </div>
      <div>You have more than 5 users, contact us at <a style="color:blue"
                                                        href="mailto:support@yoursynchronicity.com">support@yoursynchronicty.com</a>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'PricingOne',
        data() {
            return {
                pricingTable: [
                    {
                        thumb: require('../../assets/img/pricing/aeroland-branding-pricing-image-02.png'),
                        title: 'Personal',
                        value: '55',
                        duration: 'mo',
                        alt: 'YourSynchronicity price',
                        isPopular: true,
                        active: true,
                        price: ['1 User', 'Auto invite (personalized)', 'Send automated messages in bulk', 'Powerful campaign manager', 'Auto view profiles', 'Auto endorse skills',
                            'Export / import data', 'Integration with Pipedrive/ Zoho / Hubspot', 'Dedicated Proxy', 'Full Assessment of your LinkedIn', 'Sales expert support']
                    }
                ]
            }
        },
        methods: {
            gotologin() {
                this.$router.push({name: 'login'});
            },
        }
    }
</script>
